<div
  id="tiles-container"
  class="tiles-container-resources"
  fxLayout="row wrap"
  fxLayoutAlign="start"
  >
  @for (tile of filteredTileData; track $index; let i = $index) {
    <div
      id="tile_{{ i }}"
      class="base-tile tile_{{ getID(tile) }} tile-container-resources"
      fxLayout="column"
      >
      <!------------ Tile ------------>
      <!-- Resource Categories -->
      @if (resourceTiles && resourceCategories) {
        <a
          (click)="setCategoryFn(tile)"
          class="anchor-tag-wrapper"
          id="tile_anchor_wrapper_{{ i }}"
          >
          <div
            class="tile resources-tile-border resource-tile tile-resource-sizes tile-container-resources__resource-category"
            [ngClass]="getBannerClass(tile)"
            >
            <img [src]="getCategoryIcon(tile)" alt="Categorie Icon" />
            <!-- assignment/resource meta data -->
            <section class="text-holder">
              <div>
                <p
                  class="tile-text text-align-center"
                  [matTooltip]="getCategoryTileName(tile)"
                  matTooltipPosition="above"
                  >
                  {{ getCategoryTileName(tile) }}
                </p>
              </div>
            </section>
          </div>
        </a>
      }
      <!-- Resource Tile Info That needs to be opened in a new tab -->
      @if (
        resourceTiles &&
        !resourceCategories &&
        (!tile.isEmbedded)
        ) {
        <a
          [href]="getUrlForNewTab(tile)"
          (click)="openResource(tile)"
          target="_blank"
          class="anchor-tag-wrapper"
          id="tile_anchor_wrapper_{{ i }}"
          >
          <!-- Don't rip this out again lewis.^^^^^ -->
          <div
            class="tile resources-tile-border resource-tile tile-resource-sizes"
                [ngStyle]="{
                    'background-image': getTileBackgroundImageStyle(tile) + ', url(' + (getTileBackgroundImageUrl(tile) | async) + ')',
                    'background-color': getTileBackgroundColor()
                }"
            >
            <!-- assignment/resource meta data -->
            <section class="text-holder">
              <div>
                <p
                  class="tile-text text-align-center"
                  [matTooltip]="tile?.displayName"
                  matTooltipPosition="above"
                  >
                  {{ tile?.displayName }}
                </p>
              </div>
            </section>
          </div>
        </a>
      }
      <!-- Resource Tile Info That can be opened in place-->
      @if (
        resourceTiles &&
        tile.isEmbedded
        ) {
        <a
          [routerLink]="getUrlForTile(tile)"
          (click)="openResource(tile)"
          class="anchor-tag-wrapper"
          id="tile_anchor_wrapper_{{ i }}"
          >
          <!-- Don't rip this out again lewis.^^^^^ -->
          <div
            class="tile resources-tile-border resource-tile tile-resource-sizes"
                [ngStyle]="{
                    'background-image': getTileBackgroundImageStyle(tile) + ', url(' + (getTileBackgroundImageUrl(tile) | async) + ')',
                    'background-color': getTileBackgroundColor()
                }"
            >
            <!-- assignment/resource meta data -->
            <section class="text-holder">
              <div>
                <p
                  class="tile-text text-align-center"
                  [matTooltip]="tile?.displayName"
                  matTooltipPosition="above"
                  >
                  {{ tile?.displayName }}
                </p>
              </div>
            </section>
          </div>
        </a>
      }
    </div>
  }
</div>
@if (!filteredTileData.length) {
  <no-search-results></no-search-results>
}
